import {
    MLDRIVEN_ITEMS_ALGORITHM_TYPE,
    MLDRIVEN_ITEMS_TYPE,
} from "../../../pages/FlexibleLandingPage/components/MLDrivenItemsWidget/constants";
import { isPersonalizedContentEnabled } from "../../../utils/cmp/library";
import { cardNode } from "../fragments/cardNode";
import { trendingItem } from "../fragments/contentItem";

export const personalizedItemsQuery = (
    algorithmId,
    userId = "",
    pageSize,
    contentId
) => {
    const _pageSize = parseInt(pageSize);
    const allowPersonalized = isPersonalizedContentEnabled();

    return `
        query {
            personalizedItems(algorithmId: "${algorithmId}",
                              userId: "${userId}", 
                              allowPersonalized: ${allowPersonalized}, 
                              first: ${_pageSize},
                              sourceId: "${contentId}") {
                nodes {
                    ...cardNode,
                    ...trendingItem
                }
                algorithmId
            }
        }
        ${cardNode}
        ${trendingItem}
    `;
};

export const mlDrivenItemsQuery = (algorithm, args, pageSize, type) => {
    const _pageSize = parseInt(pageSize);
    const {
        algorithmType = MLDRIVEN_ITEMS_TYPE.SHORT_FORM_VIDEO,
        userId = "",
    } = args;

    const allowPersonalized = isPersonalizedContentEnabled();

    let queryArgs;
    switch (algorithm) {
        case MLDRIVEN_ITEMS_ALGORITHM_TYPE.RECOMMENDED:
            queryArgs = `{ recommendedType: "${algorithmType}", userId: "${userId}", allowPersonalized: ${allowPersonalized}}`;
            break;
        case MLDRIVEN_ITEMS_ALGORITHM_TYPE.TRENDING: {
            queryArgs = `{ trendingType: "${algorithmType}" }`;
            //TODO: Remove once experiment is done (WEBX-2658-Maritimes-AB-Test )
            if (args?.category) {
                queryArgs = `{ trendingType: "${algorithmType}",  category: ["news/canada/nova scotia", "news/canada/new brunswick", "news/canada/pei"] }`;
            }
            break;
        }

        default:
            break;
    }

    let typeArgs = "";
    switch (type) {
        case "video":
        case "story":
            typeArgs = `, type: "${type}"`;
            break;
        default:
            break;
    }

    return `
        query {
            mlDrivenItems(pageSize: ${_pageSize}, algorithm: "${algorithm}", args: ${queryArgs}${typeArgs}) {
                type
                items {
                    ...cardNode,
                    ...trendingItem
                }
            }
        }
        ${cardNode}
        ${trendingItem}
    `;
};

export const mlDrivenRelatedStoriesQuery = () => {
    return `query mediaRelatedStories($sourceId: String, $pageSize: Int) {
        relatedItems(sourceId: $sourceId, first: $pageSize, formats: ["story"]) {
            nodes {
                sourceId
                title
                url
            }
        }
    }`;
};

export const mlDrivenTrendingVideoContentItemsQuery = () => {
    return `query trendingVideoContentItems($pageSize: Int, $trendingType: String) {
        mlDrivenItems(pageSize: $pageSize, args: { trendingType: $trendingType }, algorithm: "trending", type: "video") {
            items {
                ...cardNode
            }
        }
    } ${cardNode}`;
};
